'use client';

import { useLinkClicked } from '@repo/platform-analytics/hooks/useLinkClicked';
import { LinkViewed } from '@repo/platform-analytics/LinkViewed';
import { getOrCreateId } from '@repo/platform-utils/static-ids';
import { Link } from '@repo/ui/Link';
import type { ReactNode } from 'react';
import { useRef } from 'react';
function slugify(str: string): string {
  return str.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
}
export type LinkClientProps = {
  href?: string;
  target?: string;
  rel?: string;
  linkCopy: string;
  children: ReactNode;
};
export const LinkClient = ({
  href,
  target,
  rel,
  linkCopy,
  children
}: LinkClientProps) => {
  const eventIdRef = useRef('');
  const eventId = getOrCreateId(eventIdRef);
  const destinationUrl = href ?? '';
  const fireLinkClicked = useLinkClicked({
    entityName: 'link',
    destinationUrl,
    linkCopy,
    parentEventId: eventId,
    immediate: true
  });
  return <LinkViewed entityName="link" destinationUrl={destinationUrl} linkCopy={linkCopy} eventId={eventId}>
      <Link underline="hover" data-testid={`content-link-${slugify(linkCopy)}`} rel={rel} onClick={() => fireLinkClicked()} href={href} target={target}>
        {children}
      </Link>
    </LinkViewed>;
};
LinkClient.displayName = 'StructuredContentLink.Client';